let language = {
    "BILLING-METHOD-SAFE-DATA-TIP": `
        Your data is safe—we don't store your card or billing method details, and we use
        industry-standard encryption to protect your personal information.
    `,
    "BILLING-METHOD-PRESS-PAYPAL-TIP": "Press the yellow Paypal button below to authorize your account.",
    "BILLING-METHOD-FILL-OUT-INFO-TIP": "Please finish filling out billing Info to select a billing method!",
};

export { language }